import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";

// The final capstone project — an 8-step build journey plus the concrete
// list of what a student leaves with. Only rendered for courses that carry
// a real capstone (see course.capstone in seed_data).
export default function Capstone({ capstone, testId = "capstone" }) {
  if (!capstone) return null;
  return (
    <div data-testid={testId}>
      <Reveal>
        <p className="text-lg leading-relaxed text-ink/90 max-w-2xl">{capstone.intro}</p>
      </Reveal>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {capstone.steps.map((s, i) => (
          <Reveal key={s.n} delay={(i % 4) * 0.05}>
            <div className="rounded-2xl bg-surface p-5 h-full shadow-sm">
              <span className="font-display font-bold text-3xl text-terracotta block leading-none">{s.n}</span>
              <h5 className="font-display font-semibold text-base mt-3">{s.title}</h5>
              <p className="text-graphite mt-1 leading-snug text-[13px]">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {capstone.outputs && capstone.outputs.length > 0 && (
        <Reveal delay={0.1}>
          <div className="mt-8 rounded-2xl bg-emeraldlight p-6 md:p-8">
            <p className="font-sans text-xs font-bold text-emerald mb-4 uppercase tracking-wide">What you'll build</p>
            <div className="flex flex-wrap gap-3">
              {capstone.outputs.map((o, i) => (
                <span key={i} className="inline-flex items-center gap-2 rounded-full bg-surface px-4 py-2 text-[14px] font-semibold text-ink">
                  <Check size={14} className="text-emerald shrink-0" /> {o}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      )}

      {capstone.closing && (
        <Reveal delay={0.15}>
          <p className="font-serif italic text-xl md:text-2xl leading-snug text-ink/80 mt-8 max-w-2xl">
            {capstone.closing}
          </p>
        </Reveal>
      )}
    </div>
  );
}
